import { useCallback } from "react";
import CalcRulesLib from "@ploy-lib/calc-rules";
export function useSelectedField(field) {
    const callback = useCallback((event) => {
        if (!field) {
            return;
        }
        switch (event) {
            case "CHANGE":
                CalcRulesLib.SelectedField.setChanged(field.namespace, field.name);
                break;
            case "CLICK":
                CalcRulesLib.SelectedField.setClicked(field.namespace, field.name);
                break;
            case "BLUR":
                CalcRulesLib.SelectedField.setBlur(field.namespace, field.name);
                break;
        }
    }, [field]);
    return callback;
}
//# sourceMappingURL=useSelectedField.js.map